import React from "react";

interface MobileProductFilterContainerProps {
  products: string[];
  selectedProduct?: string;
  onProductSelect: (product: string) => void;
  onClose?: () => void;
}

const MobileProductFilterContainer: React.FC<
  MobileProductFilterContainerProps
> = ({ products, selectedProduct, onProductSelect, onClose }) => {
  const hasValidSelection =
    selectedProduct && products.includes(selectedProduct);
  const defaultProduct = hasValidSelection ? selectedProduct : "AMMONIA";

  return (
    <div
      id="mobile-product-filter-container"
      style={{
        background: "white",
        width: "100%",
        borderTopLeftRadius: "16px",
        borderTopRightRadius: "16px",
        padding: "24px",
        maxHeight: "60vh",
        overflowY: "auto",
      }}
    >
      <div
        style={{
          fontSize: "18px",
          fontWeight: 600,
          marginBottom: "16px",
        }}
      >
        Select Product
      </div>
      <div className="product-grid">
        {products.map((p: string) => {
          const isSelected = p === defaultProduct;

          return (
            <button
              key={p}
              type="button"
              className={`product-card ${isSelected ? "active" : ""}`}
              onClick={() => {
                onProductSelect(p);
                if (onClose) onClose();
              }}
              style={{
                padding: "16px",
                border: isSelected ? "2px solid #2563EB" : "1px solid #E5E7EB",
                borderRadius: "8px",
                background: isSelected ? "#EFF6FF" : "white",
                cursor: "pointer",
                textAlign: "center",
                fontWeight: isSelected ? 600 : 400,
                color: "#1F2937",
              }}
            >
              <span className="prod-name" style={{ color: "#1F2937" }}>
                {p.charAt(0).toUpperCase() + p.slice(1).toLowerCase()}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default MobileProductFilterContainer;
